import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

import { IsExternal } from 'library/types';
import { CustomerBox } from 'modules/EndCustomer/Shared/CustomerBox';

import { CustomerBoxProps, EditCustomerProps } from '../types';
import {
	ChangedByInfoDisplay,
	ChangedByInfoDisplayProps,
} from './ChangedByInfoDisplay';
import { ConnectedCustomerCardDisplayButtons } from './ConnectedCustomerCardDisplayButtons';

interface ConnectedCustomerCardDisplayProps
	extends CustomerBoxProps,
		EditCustomerProps,
		IsExternal,
		ChangedByInfoDisplayProps {}

export const ConnectedCustomerCardDisplay = ({
	changedByInfo,
	customer,
	isOwner,
	...propsRest
}: ConnectedCustomerCardDisplayProps) => (
	<Paper
		className="customer-card-display__root"
		variant="flatGrey"
		sx={{
			position: 'relative',
			display: 'grid',
			gridTemplateColumns: {
				xs: 'minmax(0, 1fr)',
				sm: 'minmax(0, 2fr) 1fr',
			},
			alignItems: 'end',
			gap: 2,
			flex: 1,
			'& > .text-display__root': {
				justifySelf: 'end',
			},
		}}>
		<Box
			sx={{
				alignSelf: 'start',
			}}>
			<CustomerBox customer={customer} isOwner={isOwner} />
		</Box>
		<ChangedByInfoDisplay changedByInfo={changedByInfo} />
		<ConnectedCustomerCardDisplayButtons
			customer={customer}
			isOwner={isOwner}
			{...propsRest}
		/>
	</Paper>
);
